import {Box, Typography, Paper} from '@mui/material';
import {SessionQuestion} from '@cp/model';
import MarkdownContentRenderer from '../../atoms/MarkdownContentRenderer/MarkdownContentRenderer';

interface QuestionReviewQuestionExplanationProps {
  question: SessionQuestion;
}

export default function QuestionReviewQuestionExplanation({question}: QuestionReviewQuestionExplanationProps) {
  if (!question.explanation) return null;

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{mb: 1, fontWeight: 500}}>
        Explanation:
      </Typography>
      <Paper
        sx={{
          p: {xs: 1.5, sm: 2},
          bgcolor: 'info.50',
          border: '1px solid',
          borderColor: 'info.200',
          borderRadius: 1,
        }}
      >
        <Typography
          component="div"
          variant="body2"
          sx={{
            lineHeight: 1.5,
            wordBreak: 'break-word', // Handle long words on mobile
          }}
        >
          <MarkdownContentRenderer content={question.explanation} />
        </Typography>
      </Paper>
    </Box>
  );
}
